import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowRight, Zap } from 'lucide-react';

const ThankYouPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center">
        {/* Success Icon */}
        <div className="mb-8">
          <div className="w-20 h-20 mx-auto bg-green-500/10 rounded-full flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-green-500" />
          </div>
        </div>

        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-10 h-10 bg-indigo-600 rounded-lg flex items-center justify-center">
            <Zap className="w-6 h-6 text-white" />
          </div>
          <span className="font-['Outfit'] text-xl font-bold text-white">Hyper Local</span>
        </div>

        {/* Message */}
        <h1 
          className="font-['Outfit'] text-3xl md:text-4xl font-bold text-white mb-4"
          data-testid="thank-you-title"
        >
          You're on the list!
        </h1>
        
        <p className="text-slate-400 text-lg mb-8" data-testid="thank-you-message">
          Thanks for your interest in Hyper Local. We'll be in touch soon with early access details and next steps.
        </p>

        {/* What to expect */}
        <div className="card-base text-left mb-8">
          <h3 className="font-['Outfit'] font-semibold text-white mb-4">What happens next?</h3>
          <ul className="space-y-3">
            <li className="flex items-start gap-3 text-slate-300">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-indigo-500/20 text-indigo-400 flex items-center justify-center text-sm font-semibold">1</span>
              <span>We'll review your application within 24 hours</span>
            </li>
            <li className="flex items-start gap-3 text-slate-300">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-indigo-500/20 text-indigo-400 flex items-center justify-center text-sm font-semibold">2</span>
              <span>You'll receive an email with your account setup link</span>
            </li>
            <li className="flex items-start gap-3 text-slate-300">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-indigo-500/20 text-indigo-400 flex items-center justify-center text-sm font-semibold">3</span>
              <span>Install our WordPress plugin and start generating pages</span>
            </li>
          </ul>
        </div>

        {/* CTA */}
        <button
          onClick={() => navigate('/')}
          className="btn-secondary inline-flex items-center gap-2"
          data-testid="back-to-home-btn"
        >
          Back to Home
          <ArrowRight className="w-4 h-4" />
        </button>

        {/* Footer note */}
        <p className="text-slate-500 text-sm mt-8">
          Questions? Email us at{' '}
          <a href="mailto:hello@hyperlocal.io" className="text-indigo-400 hover:text-indigo-300">
            hello@hyperlocal.io
          </a>
        </p>
      </div>
    </div>
  );
};

export default ThankYouPage;
